import { useToast } from '@chakra-ui/react';

export const ToastService = () => {
    const toast = useToast();
    const showToast = (title, description, status) => {
        toast({
            title,
            description,
            status,
            duration: 5000,
            isClosable: true,
        });
    };

    const success = (title, description) => showToast(title, description, "success");
    const error = (title, description) => showToast(title, description, "error");
    const info = (title, description) => showToast(title, description, "info");
    const warning = (title, description) => showToast(title, description, "warning");

    return { success, error, info, warning };
};
